<template>
  <modal
    :is-opened="isOpened"
    :on-close="close"
  >
    <template #header>
      {{ modalTitle }}
    </template>
    <template #body>
      <div class="modal-state">
        <p>
          {{ trans('user.modal.delete_success.content') }}
        </p>
        <p>
          <button
            type="button"
            class="btn btn--primary"
            @click="close"
          >
            {{ trans('global.close') }}
          </button>
        </p>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@components/Modal.vue';
import { translationMixin } from '@tools/translation';

/**
 * Delete Success User modal component
 */
export default {
  components: {
    Modal,
  },
  mixins: [ translationMixin ],
  props: {
    isOpened: { type: Boolean, default: false },
  },
  data() {
    return {
      modalTitle: '',
    };
  },
  watch: {
    isOpened(newVal) {
      if (!newVal) {
        return;
      }
      this.modalTitle = this.trans('user.modal.delete.title');
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
